import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../Components/ButtonCustom'
import Input from '../../../../Components/CustomUi/input'
import { TitleH1 } from '../../../../Components/CustomUi/titleH1'
import PageContainer from '../../../../Components/pageContainer'
import { ContainerCargos } from './styles'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { Inline } from '../../../../Components/CustomUi/inline'
import { SetStateAction, useEffect, useState } from 'react'
import FormularioCargos from './components/formulario'
import { TabelaCargos } from './components/tabela'
import { useGetCargos, useGetEditarCargos } from '../../../../services/cadastroCargos/get'
import { usePostCargo, usePutCargo } from '../../../../services/cadastroCargos/post'
import { useDeleteCargo } from '../../../../services/cadastroCargos/delete'

const CadastroCargos: React.FC = () => {
  //FORMULARIO
  const [openGaveta, setOpenGaveta] = useState<boolean>(false)
  const [nomeCargo, setNomeCargo] = useState<string>('')
  const [descricaoCargo, setDescricaoCargo] = useState<string>('')
  const [listarCargo, setListarCargo] = useState([])
  const [editarCargo, setEditarCargo] = useState<number>(0)
  const [loadingEditar, setLoadingEditar] = useState<boolean>(false)

  //TABELA
  const [buscarTabela, setBuscarTabela] = useState<string>('')
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)

  //API
  const { carregando_cargos, data_cargos, refetch_data_cargos } = useGetCargos(
    pagination,
    page,
    buscarTabela
  )
  const { data_cargos_editar, refetch_data_cargos_editar } = useGetEditarCargos(editarCargo)
  const { mutate_cargos, carregando_salvar_cargos } = usePostCargo()
  const { mutate_edit_cargos, carregando_edit_cargos } = usePutCargo(editarCargo)
  const { mudateDeletarCargo } = useDeleteCargo()

  function fecharGaveta() {
    setEditarCargo(0)
    setOpenGaveta(false)
    setNomeCargo('')
    setDescricaoCargo('')
  }

  function cadastrarAtualizar() {
    if (editarCargo > 0) {
      mutate_edit_cargos({
        nome: nomeCargo,
        descricao: descricaoCargo,
        refetch_cargos: () => {
          refetch_data_cargos()
          fecharGaveta()
        },
      })
    } else {
      mutate_cargos({
        nome: nomeCargo,
        descricao: descricaoCargo,
        refetch_cargos: () => {
          refetch_data_cargos()
          fecharGaveta()
        },
      })
    }
  }

  function excluirCargo(cod) {
    setFake_loading(true)
    mudateDeletarCargo({
      cod_cargo: cod,
      refetch_deletar: () => refetch_data_cargos(),
    })
    setTimeout(() => {
      setFake_loading(false)
    }, 3000)
  }

  useEffect(() => {
    if (data_cargos_editar?.itens?.length > 0) {
      setLoadingEditar(true)
      setNomeCargo(data_cargos_editar?.itens[0]?.nome)
      setDescricaoCargo(data_cargos_editar?.itens[0]?.descricao)
      setOpenGaveta(true)
      setTimeout(() => {
      setLoadingEditar(false)
    }, 500)
    }
  }, [data_cargos_editar])

  useEffect(() => {
    if (buscarTabela.length > 2) {
      setTimeout(() => {
        refetch_data_cargos()
      }, 700)
    }
    if (buscarTabela === '') {
      refetch_data_cargos()
    }
  }, [buscarTabela])

  useEffect(() => {
    refetch_data_cargos()
  }, [page, pagination])

  useEffect(() => {
    if (editarCargo > 0) {
      refetch_data_cargos_editar()
    }
  }, [editarCargo])

  useEffect(() => {
    refetch_data_cargos()
  }, [])
  console.log('editar', editarCargo, openGaveta)
  return (
    <ContainerCargos>
      <PageContainer>
        <TitleH1>Cadastro de cargos</TitleH1>
        <TabelaCargos
          setPagination={setPagination}
          setPage={setPage}
          page={page}
          carregando_cargos={carregando_cargos}
          listar_cargos={data_cargos?.itens}
          total={data_cargos?.total}
          excluirCargo={excluirCargo}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          setFake_loading={setFake_loading}
          buscarTabela={buscarTabela}
          setBuscarTabela={setBuscarTabela}
          setEditarCargo={setEditarCargo}
          setOpenGaveta={setOpenGaveta}
        />
      </PageContainer>
      <FormularioCargos
        nomeCargo={nomeCargo}
        setNomeCargo={setNomeCargo}
        descricaoCargo={descricaoCargo}
        setDescricaoCargo={setDescricaoCargo}
        editar={editarCargo}
        openGaveta={openGaveta}
        fecharGaveta={fecharGaveta}
        cadastrar={cadastrarAtualizar}
        loadingSalvar={carregando_salvar_cargos ?? carregando_edit_cargos}
        loadingEditar={loadingEditar}
      />
    </ContainerCargos>
  )
}

export default CadastroCargos
